import { ADMIN } from 'components/RoleGate/constants';
import RoleModal from 'components/RoleModal';
import React from 'react';
import { Grid, Modal } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { requestedExportGroupedPeople } from 'services/people/actions';
// @ts-ignore
import { selectSelectedTableCellRows } from 'services/selectedTableCells/selectors';
import QueryStringButton from 'components/QueryStringButton';
import SubmittingButton from 'components/SubmittingButton';
import { PERSON_GROUPED_PEOPLE_EXPORT_NAMESPACE } from 'services/people/constants';
import ErrorAlert from 'components/ErrorAlert';

export const EXPORT_PEOPLE_MODAL = 'EXPORT_PEOPLE_MODAL';

export default function ExportPeopleModal(): React.ReactElement | null {
    const dispatch = useDispatch();
    const peopleIds: number[] = useSelector(selectSelectedTableCellRows);

    if (!peopleIds.length) {
        return null;
    }

    const handleExportClick = (): void => {
        dispatch(requestedExportGroupedPeople(peopleIds));
    };

    return (
        <RoleModal
            param={EXPORT_PEOPLE_MODAL}
            requiredRoles={[ADMIN]}
            size="tiny"
        >
            <React.Fragment>
                <Modal.Header>Export people</Modal.Header>
                <Modal.Content className="constrain-width">
                    <p>
                        The selected people will be exported to a CSV file. This
                        can be imported in Organisations page to add people to a
                        different organisation. Do you want to continue?
                    </p>
                    <ErrorAlert
                        namespace={PERSON_GROUPED_PEOPLE_EXPORT_NAMESPACE}
                    />
                    <Grid>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <QueryStringButton
                                params={{
                                    [EXPORT_PEOPLE_MODAL]: undefined
                                }}
                                buttonProps={{
                                    type: 'button',
                                    fluid: true,
                                    basic: true,
                                    primary: true
                                }}
                                ignoreActive
                            >
                                Cancel
                            </QueryStringButton>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <SubmittingButton
                                namespace={
                                    PERSON_GROUPED_PEOPLE_EXPORT_NAMESPACE
                                }
                                type="button"
                                primary
                                fluid
                                onClick={handleExportClick}
                            >
                                Export
                            </SubmittingButton>
                        </Grid.Column>
                    </Grid>
                </Modal.Content>
            </React.Fragment>
        </RoleModal>
    );
}
